export class BaseResource<TID> {
  id!: TID;
  label!: string;
}
